import { gql } from '@apollo/client';

const schema = {
  get: {
    name: 'role',
    serviceName: 'shopadmin',
    query: gql`
      query role($ids: [String]) {
        role(ids: $ids) {
          data {
            name
            title
          }
        }
      }
    `,
  },
  update: {
    name: 'updateRole',
    serviceName: 'admin',
    query: gql`
      mutation updateRole($ids: [String]!, $title: String, $name: String) {
        updateRole(ids: $ids, title: $title, name: $name) {
          messages
        }
      }
    `,
  },
};

export default schema;
